// Web mock for @sentry/react-native that delegates to @sentry/browser
// Uses no-op functions to avoid requiring @sentry/browser installation

const noop = (..._args: any[]) => {};
const noopAsync = async (..._args: any[]) => {};

export function init(options?: any) {
  if (options?.dsn) {
    console.log('[Sentry Web] Initialized with DSN (no-op in web mock)');
  }
}

export function captureException(exception: any, hint?: any) {
  console.error('[Sentry Web] captureException:', exception);
  return '';
}

export function captureMessage(message: string, level?: any) {
  console.log('[Sentry Web] captureMessage:', message);
  return '';
}

export function captureEvent(event: any) {
  console.log('[Sentry Web] captureEvent:', event);
  return '';
}

export function setUser(user: any) {}
export function setTag(key: string, value: string) {}
export function setTags(tags: Record<string, string>) {}
export function setExtra(key: string, extra: any) {}
export function setExtras(extras: Record<string, any>) {}
export function setContext(name: string, context: any) {}
export function addBreadcrumb(breadcrumb: any) {}

export function withScope(callback: (scope: any) => void) {
  const scope = {
    setUser: noop,
    setTag: noop,
    setTags: noop,
    setExtra: noop,
    setExtras: noop,
    setContext: noop,
    setLevel: noop,
    setFingerprint: noop,
    addBreadcrumb: noop,
    clear: noop,
  };
  callback(scope);
}

export function wrap(component: any) {
  return component;
}

export const Severity = {
  Fatal: 'fatal',
  Error: 'error',
  Warning: 'warning',
  Log: 'log',
  Info: 'info',
  Debug: 'debug',
};

export const ReactNavigationInstrumentation = class {
  registerNavigationContainer = noop;
};

export const ReactNativeTracing = class {
  constructor(_options?: any) {}
};

export default {
  init,
  captureException,
  captureMessage,
  captureEvent,
  setUser,
  setTag,
  setTags,
  setExtra,
  setExtras,
  setContext,
  addBreadcrumb,
  withScope,
  wrap,
  Severity,
  ReactNavigationInstrumentation,
  ReactNativeTracing,
};
